/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuShapeCircle4Icon16Light = forwardRef('UiMenuShapeCircle4Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-2 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-2 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" })));
});
